import { render } from "./ModalDetailProduct.vue?vue&type=template&id=3b64a514&scoped=true"
import script from "./ModalDetailProduct.vue?vue&type=script&lang=js"
export * from "./ModalDetailProduct.vue?vue&type=script&lang=js"

import "./ModalDetailProduct.vue?vue&type=style&index=0&id=3b64a514&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b64a514"]])

export default __exports__